$(document).ready(function() {
  $('.items_list_wrapper.addons-swatch .items_list_item').each(function() {
    var getId = '#' + $(this).attr('id');
    $(getId + ' .item_slider_conatiner').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: true
    });
  });

  setTimeout(function() {

    $('.items_list_wrapper.addons-swatch .items_list_item.slick-cloned').each(function() {
      var getSlickIndex = $(this).data('slick-index');
      $(`.items_list_item[data-slick-index=${getSlickIndex}]` + ' .item_slider_conatiner').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true
      });
    });

    $('input.checkbox_color:checked').each(function() {
      var variantImgId = $(this).data('img-id');
      moveSliderToSelectedTileImage(variantImgId);
    });

  },150);

  $('input.checkbox_color').click(function() {
    if ($(this).data('img-id')) {
      if($(`input.checkbox_color[data-img-id=${$(this).data('img-id')}]`).is(':checked')) {
        $(`input.checkbox_color[data-img-id=${$(this).data('img-id')}]`).prop("checked", true);
        var variantImgId = $(this).data('img-id');
        moveSliderToSelectedTileImage(variantImgId);
      }
    }
  });

  function moveSliderToSelectedTileImage(variantImgId) {
    if (variantImgId) {
      $('.items_list_wrapper.addons-swatch .items_list_item').each(function() {
        var getId ;
        if ($(this).attr('id')) {
          getId = '#' + $(this).attr('id');
        } else {
          getId = `.items_list_item[data-tile-id=${$(this).data('tile-id')}]`;
        }
        if (getId) {
          $(getId + ' .item_slider_conatiner img').each(function (index, elm) {
            var elmId;
            if (elm.id) {
              elmId = elm.id;
            } else {
              elmId = $(elm).data('img-id')
            }
            if (elmId  == variantImgId) {
              if ( index > -1) {
                $(getId + ' .item_slider_conatiner').slick('slickGoTo', index - 1, false);
              }
              return false;
            } 
          });
        } 
      });
    }
  }

});
